import React from 'react';
import { connect } from 'react-redux';
import InternalPageTypes from '../internal-page-types';

const mapStateToProps = ({ App }) => ({
    hasUpdate: App.hasUpdate,
});

const Wrapper = ({ hasUpdate, saveChanges, pageType, scroll, ...props }) => {
    const isClassOrCourse = pageType === InternalPageTypes.CLASS_RESOURCE || pageType === InternalPageTypes.COURSE_RESOURCE;
    return (
        <div className='app-body'>
            <div className='content-wrapper'>
                {props.children}
            </div>
            <div className='left-side-container'>
                {isClassOrCourse &&
                <div className='admin-toolbar'>
                    <button
                        className={`admin-toolbar-btn ${scroll ? 'top' : ''}`}
                        disabled={!hasUpdate}
                        title='Salvar alterações'
                        onClick={() => hasUpdate && saveChanges()}
                    >
                        <i className='fa fa-save'/>
                    </button>
                </div>}
            </div>
        </div>
    );
};

export default connect(mapStateToProps)(Wrapper);



// WEBPACK FOOTER //
// ./src/components/internal-pages/components/pages-wrapper.js